module.exports = __webpack_public_path__ + "static/media/profile-list.6752734d.svg";